import { FROM_MODULE_TYPE } from '@utils/constants'

import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/attachments'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

function GenerateAudioTranscription(id: string, language: string) {
  return ApiRequest.post(
    `${BaseRoute}/${id}/generateAudioTranscription?language=${language}`
  )
}
const MergeFiles = (data: MergeFileInputDto) => {
  return ApiRequest.post(`${BaseRoute}/MergeFiles`, data)
}

const GetAttachmentTypes = () => {
  return ApiRequest.get(`${BaseRoute}/attachmentTypes`)
}

const SummaryDocument = (id: string) => {
  return ApiRequest.post(`${BaseRoute}/${id}/summaryDocument`)
}

const CleanupFile = (attachmentId: string) => {
  return ApiRequest.post(`${BaseRoute}/${attachmentId}/cleanup`)
}

const DocumentSearch = (query: string) => {
  return ApiRequest.get(`${BaseRoute}/documentSearch?keyword=${query}`)
}

const ExtractLOIData = (attachmentId: string, disableCache = false) => {
  return ApiRequest.post(
    `${BaseRoute}/${attachmentId}/extractLOIData?disableCache=${disableCache}`
  )
}

/** One Specialty / Accreditation row of the Doc QA Result, compared on the server. */
export interface LoiCredentialCheckRowDto {
  caseValue: string | null
  letterValue: string | null
  isMatched: boolean | null
  note: string | null
}

export interface LoiCredentialCheckDto {
  specialty: LoiCredentialCheckRowDto
  accreditation: LoiCredentialCheckRowDto
}

/**
 * The Doc QA Result's Specialty and Accreditation rows: what the letter's
 * cached QA reading calls for against the given specialist's profile. Reads
 * only — never runs the AI.
 */
const GetLoiCredentialCheck = (
  attachmentId: string,
  specialistId: string | null
) => {
  const query = specialistId ? `?specialistId=${specialistId}` : ''
  return ApiRequest.get<LoiCredentialCheckDto>(
    `${BaseRoute}/${attachmentId}/loiCredentialCheck${query}`
  )
}

const ExtractReportQAData = (
  attachmentId: string,
  loiAttachmentId: string = null,
  disableCache = false
) => {
  const loiParam = loiAttachmentId ? `&loiAttachmentId=${loiAttachmentId}` : ''
  return ApiRequest.post(
    `${BaseRoute}/${attachmentId}/extractReportQAData?disableCache=${disableCache}${loiParam}`
  )
}

const DetectRedaction = (attachmentId: string, instruction: string = null) => {
  return ApiRequest.post(`${BaseRoute}/${attachmentId}/detect-redaction`, {
    instruction,
  })
}

const ApplyRedaction = (attachmentId: string, mode: string = 'redact') => {
  return ApiRequest.post(
    `${BaseRoute}/${attachmentId}/apply-redaction?mode=${mode}`
  )
}

/**
 * Submit the reviewer-approved redaction result. The backend stores the
 * corrections as tenant learning samples (prompt refinement for future
 * automatic runs) and updates the attachment's redaction metadata, so the
 * subsequent ApplyRedaction uses exactly what the reviewer approved.
 */
const SubmitRedactionFeedback = (
  attachmentId: string,
  payload: {
    finalItems: any[]
    manualRectangles: { page_number: number; rects: any[] }[]
  }
) => {
  return ApiRequest.post(
    `${BaseRoute}/${attachmentId}/redaction-feedback`,
    payload
  )
}

const API = {
  ...baseFunctions,
  GenerateAudioTranscription,
  MergeFiles,
  GetAttachmentTypes,
  SummaryDocument,
  CleanupFile,
  DocumentSearch,
  ExtractLOIData,
  GetLoiCredentialCheck,
  ExtractReportQAData,
  DetectRedaction,
  ApplyRedaction,
  SubmitRedactionFeedback,
}

export default API
export class MergeFileInputDto {
  objectId: string
  fromModuleType: FROM_MODULE_TYPE
  attachmentTypeEnums: any[]
  mergedAttachmentType: any
  fileName: string
}
